// extracted by mini-css-extract-plugin
export default {"main":"LocationWrapperStyles_main__gHRB6"};